import { render, staticRenderFns } from "./TabletShowcaseSection.vue?vue&type=template&id=57687c1a&scoped=true"
import script from "./TabletShowcaseSection.vue?vue&type=script&lang=js"
export * from "./TabletShowcaseSection.vue?vue&type=script&lang=js"
import style0 from "./TabletShowcaseSection.vue?vue&type=style&index=0&id=57687c1a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57687c1a",
  null
  
)

export default component.exports